export default __webpack_public_path__ + "static/media/icon_newe.5a5fc098.png";